import { IWorkflow } from '@/interfaces/ICalendarWorkflows';

export const getTextBookingWorkflows = (clientObject: any): IWorkflow[] => {
	if (!clientObject?.workflows) {
		return [];
	}
	try {
		const textWorkflows = JSON.parse(clientObject.workflows) || [];
		return textWorkflows.filter((w: IWorkflow) => w.bookingText === true);
	} catch {
		return [];
	}
};

export const getBookingRequestWorkflows = (clientObject: any): IWorkflow[] => {
	if (!clientObject?.intake_questions_workflows) {
		return [];
	}
	try {
		const intakeWorkflows = JSON.parse(clientObject.intake_questions_workflows) || [];
		return intakeWorkflows.filter((w: IWorkflow) => w.bookingRequest === true);
	} catch {
		return [];
	}
};
